export default {
  "Autocomplete.all_number_selected": "Los {number} seleccionados",
  "Autocomplete.all_number": "Los ({number})",
  "Card.toggle_content": "alternar contenido",
  "Chip.remove": "retirar",
  "DatePicker.next": "Próximo",
  "DatePicker.previous": "Previo",
  "Pagination.first": "primero",
  "Pagination.go_to_page_number": "Ir a la página {index}",
  "Pagination.go_to_page": "Ir a la {label} pagina",
  "Pagination.last": "último",
  "Pagination.next": "próximo",
  "Pagination.previous": "previo",
  "Table.actions": "Acciones de tabla",
  "Table.add_column": "Añadir columna",
  "Table.clear_selection": "Borrar selección",
  "Table.filter": "Filter",
  "Table.hide": "Esconder",
  "Table.more_actions": "Mas acciones",
  "Table.move_left": "Mover hacia la izquierda",
  "Table.move_right": "Mover a la derecha",
  "Table.pagination": "Paginación de tablas",
  "Table.pagination_loading": "Cargando controles de paginación de tablas",
  "Table.per_page": "Por página",
  "Table.position_zero": "0 de {total}",
  "Table.position": "{start}-{end} de {total}",
  "Table.search": "Buscar",
  "Table.select_all": "Seleccionar todo",
  "Table.select_all_n": "Seleccionar los {count}",
  "Table.select_row": "Seleccione {row}",
  "Table.sort_ascending": "Orden ascendente",
  "Table.sort_descending": "Orden descendiente",
  "TextInput.clear_labelled_input": "Limpiar {label}",
  "Ui.clear_all": "Limpiar todo",
  "Ui.close": "Cerca",
  "Ui.loading": "Cargando",
  "Ui.no_results": "No hay resultados",
  "Ui.number_selected": "{number} seleccionados",
  "Ui.remove": "Remover",
  "Ui.select_all": "Seleccionar todo",
  "Ui.show_more": "+ {count} Más",
}
